import { createAtlAttributionHeader } from '../../../../../common/fetch/atl-attribution-header';
import { fetchAggResponse } from '../../../../../common/fetch/fetch-agg-response';

import { BOOKMARK_OPERATION_NAME, BookmarkQuery } from './BookmarkQuery';

type BookmarkVariables = {
	cloudId: string;
	keyPhrase: string;
};

export enum BookmarkState {
	ACTIVE = 'ACTIVE',
	SUGGESTED = 'SUGGESTED',
}

export interface ErrorExtension {
	statusCode: number;
	errorType: string;
}

export type Bookmark = {
	id: string;
	properties: {
		url: string;
		title: string;
		description: string;
		bookmarkState: BookmarkState;
		lastModifierAccountId: string;
		keyPhrase: string;
		parentAdminhubBookmarkId?: string;
	};
	extensions?: ErrorExtension[];
};

type BookmarkData = {
	knowledgeDiscovery?: {
		bookmark: Bookmark;
	};
};

export type BookmarkResponse = {
	data?: Bookmark;
	requestId: string | null;
};

export const fetchBookmark = async (
	variables: BookmarkVariables,
	workspaceId: string,
	product: string,
): Promise<BookmarkResponse> => {
	return fetchAggResponse<BookmarkVariables, BookmarkData>({
		graphQuery: BookmarkQuery,
		variables,
		operationName: BOOKMARK_OPERATION_NAME,
		headers: createAtlAttributionHeader({
			atlWorkspaceId: workspaceId,
			tenantId: variables.cloudId,
			product,
		}),
	}).then((response) => {
		return {
			data: response.data?.knowledgeDiscovery?.bookmark,
			requestId: response.extensions?.gateway?.request_id ?? null,
		};
	});
};
